import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';
import { useSPVs } from 'src/hooks/useSPVs';

interface Props {
  disabled?: boolean;
}

export const SPVSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  const spvs = useSPVs();

  return (
    <DefaultSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.issuer.fields.issuer.label')}
      fieldName="investmentDetails.spv"
      formik={formik}
      options={
        spvs?.map((spv) => ({
          label: spv.companyName,
          value: spv._id,
        })) || []
      }
    />
  );
};
